export const EIN_FORMAT = {
  canonical: '12-3456789',
  pattern: /^\d{2}-\d{7}$/,

  validate(value: string): boolean {
    return this.normalize(value) !== undefined
  },

  normalize(value: string | undefined | null): string | undefined {
    if (!value) return undefined
    const digits = value.replace(/\D/g, '')
    if (digits.length !== 9) return undefined
    return `${digits.slice(0, 2)}-${digits.slice(2)}`
  },

  format(value: string): string {
    const digits = value.replace(/\D/g, '').slice(0, 9)
    if (digits.length <= 2) return digits
    return `${digits.slice(0, 2)}-${digits.slice(2)}`
  },

  errorMessage: 'EIN must be 9 digits (XX-XXXXXXX)',
} as const
